import { Window, WindowMoveEvent } from '@progress/kendo-react-dialogs';
import { IChatHeaderProps, IChatProps } from '../types/IChatProps';
import Chat from './Chat';
import './Chat.scss'
import { ChatApi } from '../redux/api/ChatApi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ChatHeader from './ChatHeader';
import { useReduxDispatch } from '../redux/hooks';
import { LeaveChat, MarkAsRead, ToggleChat } from '../redux/reducers/ChatSlice';
import React, { useEffect } from 'react';
import { PartialSpinny } from './Common/Spinny';
import IChatPin from '../types/IChatPin';
import { ChatIsUnRead } from '../util/ChatUtils';


export default function ChatDialog(props: IChatProps) {
    const { id } = useParams();
    const chatId = props.id || id;
    const { data: chat } = ChatApi.useGetChatQuery(chatId, { skip: !chatId });
    const { data: config } = ChatApi.useGetConfigQuery();

    const { data: userProfile } = ChatApi.useGetProfileQuery();
    const [unpinChat] = ChatApi.useUnpinChatMutation();
    const [leaveChat] = ChatApi.useLeaveChatMutation();
    const navigate = useNavigate();
    const dispatch = useReduxDispatch();
    const [windowStage, setWindowStage] = React.useState<string>('MINIMIZED')
    //const chat = result.data;


    //Set the initial expanded / collapsed state
    useEffect(() => {
        if (chat) {
            var expanded = chat.Staff_Uid === userProfile?.Uid ? chat?.Staff_Expanded : chat?.EndUser_Expanded;
            setWindowStage(expanded ? 'DEFAULT' : 'MINIMIZED');
        }
        //else
        //    trigger(chatId);

    }, [chat])


    const headerProps: IChatHeaderProps = (chat?.EndUserContact_Id === userProfile?.Id
        ? { image: chat?.Staff_Profile_Path ?? config?.Chat_Image, header: chat?.EndUser_Header, subheader: chat?.EndUser_Sub_Header, uId: chat?.Staff_Uid, conversationUid: chatId }
        : { image: chat?.EndUser_Profile_Path, header: chat?.Staff_Header, subheader: chat?.Staff_Sub_Header, uId: chat?.EndUser_Uid, conversationUid: chatId })

    const windowClosed = async () => {
    }

    //Staff accepts a chat request.
    const leaveCurrentChat = async () => {
        if (!window.confirm('Are you sure you want to permanently close this chat session?'))
            return;

        const result = await leaveChat(chat).unwrap().then((res) => {
            //Tell chat Server we have closed the chat
            dispatch(LeaveChat(chat));
        });

    }

    ///Staff unpins the chat
    const unpinCurrentChat = async () => {
        userProfile.Features.Chat && props.unPinned(chat);

        userProfile.Features.Chat
            ? unpinChat({ Chat_Id: chat.Id, Contact_Id: userProfile.Id, Pinned: true, ConversationId: chat.ConversationId } as IChatPin).unwrap()//updateChat({ ...chat, Staff_Pinned: false } as IChat).unwrap() //Staff can simply close the chat
            : await leaveCurrentChat() //End users permanently leave for good.

    }

    const windowChange = (e) => {
        //Update local state
        setWindowStage(e.state);

        var collapsed = e.state === 'MINIMIZED';

        //Toggle via the Chat hub so it can notify all other users and have them update the Chat object in state
        dispatch(ToggleChat({ conversationId: chat.ConversationId, uId: userProfile.Uid, expanded: !collapsed }));


        //Mark the chat as read
        var markAsRead = false;
        if (ChatIsUnRead(userProfile?.Uid, chat)) {
            //markAsRead = true;
            dispatch(MarkAsRead({ conversationId: chat.ConversationId, contactId: userProfile.Id, unRead: false }));
        }

    }

    const windowTitle = (<ChatHeader {...headerProps} onClick={() => { windowChange({ state: 'DEFAULT' }) }} />)
    //const windowStyle = { backgroundColor: '#'userProfile?.Nav_Hex_Color } //{ background: `linear-gradient(to bottom, ${userProfile?.Nav_Hex_Color}, #ffffff)` };
    return (
        <>
            <Window appendTo={props.anchor} style={{ background: userProfile?.Nav_Hex_Color, boxShadow: '-3px 4px 9px 0 #989898' }} title={windowTitle} width={400} height={400} initialLeft={props.leftPx} className={windowStage == 'MINIMIZED' ? 'chat-window-collapsed chat-window chat-dialog' : 'chat-window chat-dialog'}
                onStageChange={windowChange} stage={windowStage} onClose={unpinCurrentChat}
                maximizeButton={() =>
                    <Link className='k-icon k-i-maximize' target={`ChatWindow_${chatId}`} to={`/chat/${chatId}`}></Link>
                }>
                {/* {isFetching || unPinning || chatUpdating
                    ? <PartialSpinny />
                    : 
                } */}
                <Chat {...props} showHeader={false} />
            </Window>
        </>
    )
}
